import { AbstractControl, AsyncValidatorFn } from '@angular/forms'
import { Observable, of, timer } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { StaffService } from 'src/app/core/services/staff/staff.service'

export function emailAvailabilityValidator(staffService: StaffService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
        // Check if the control has been touched or its value has changed
        if (!control.dirty && !control.value) {
            // Return null if the control hasn't been touched or has no value
            return of(null)
        }

        return timer(500).pipe(
            switchMap(() =>
                staffService
                    .checkIfEmailExists(control.value)
                    .pipe(map((result) => (result ? { emailTaken: true } : null)))
            )
        )
    }
}
